import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '@/lib/supabase';

const menuItems = [
  { path: '/admin', label: 'Dashboard', icon: 'ri-dashboard-line' },
  { path: '/admin/atas', label: 'Atas', icon: 'ri-file-list-3-line' },
  { path: '/admin/produtos', label: 'Produtos', icon: 'ri-shopping-bag-3-line' },
];

export default function AdminSidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    if (supabase) {
      await supabase.auth.signOut();
    }
    localStorage.removeItem('donnos_admin_auth');
    navigate('/admin/login');
  };

  const handleAdminSupport = () => {
    window.open('https://wa.me/5521989013039', '_blank', 'noopener,noreferrer');
  };

  return (
    <aside className="w-64 bg-donnos-dark min-h-screen fixed left-0 top-0 flex flex-col">
      {/* Logo */}
      <div className="p-6 border-b border-white/10">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 flex items-center justify-center">
            <img
              src="/assets/donnos-admin-logo.png"
              alt="Donnos"
              className="h-full w-full object-contain"
            />
          </div>
          <div>
            <h1 className="text-white font-bold text-lg leading-tight">DONNOS</h1>
            <p className="text-gray-400 text-xs">Painel Administrativo</p>
          </div>
        </div>
      </div>

      {/* Menu */}
      <nav className="flex-1 p-4">
        <ul className="space-y-1">
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <li key={item.path}>
                <button
                  onClick={() => navigate(item.path)}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors text-left ${
                    isActive
                      ? 'bg-donnos-green text-white'
                      : 'text-gray-400 hover:text-white hover:bg-white/5'
                  }`}
                >
                  <i className={`${item.icon} text-lg`}></i>
                  {item.label}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Bottom actions */}
      <div className="p-4 border-t border-white/10 space-y-1">
        <button
          onClick={() => navigate('/')}
          className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-gray-400 hover:text-white hover:bg-white/5 transition-colors text-left"
        >
          <i className="ri-arrow-left-line text-lg"></i>
          Voltar ao site
        </button>
        <button
          onClick={handleAdminSupport}
          className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-gray-400 hover:text-white hover:bg-white/5 transition-colors text-left"
        >
          <i className="ri-whatsapp-line text-lg"></i>
          Suporte ao Administrador
        </button>
        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-red-400 hover:text-red-300 hover:bg-red-500/10 transition-colors text-left"
        >
          <i className="ri-logout-box-r-line text-lg"></i>
          Sair
        </button>
      </div>
    </aside>
  );
}
